<template>
  <div>
    <h3>Taste {{ buttonNum }}</h3>
    <v-container fluid>
      <v-row
        v-if="
          typeof keyConfig.Channel.value === 'number' &&
          typeof keyConfig.CommandGrp.value === 'number'
        "
      >
        <v-col cols="12" md="6" class="pl-0">
          <v-select
            v-model="keyConfig.Channel.value"
            label="Kanal"
            prepend-inner-icon="mdi-text-short"
            :items="
              channels.map((channel) => ({
                value: channel.value,
                title: channel.name,
              }))
            "
            density="compact"
            hide-details="auto"
          />
        </v-col>
        <v-col class="pr-0">
          <v-select
            v-model="keyConfig.CommandGrp.value"
            label="Funktion"
            prepend-inner-icon="mdi-text-short"
            :items="
              MaxFlexButtonFunction.map((func) => ({
                value: func.value,
                title: func.name,
              }))
            "
            density="compact"
            hide-details="auto"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="typeof keyConfig?.Priority?.value === 'number'"
          cols="12"
          md="6"
          class="pl-0"
        >
          <v-select
            v-model="keyConfig.Priority.value"
            label="Priorität"
            :items="[0, 1]"
            density="compact"
            hide-details="auto"
          />
        </v-col>
        <v-col>
          <v-switch
            :model-value="nightLED"
            label="Nacht-LED"
            color="primary"
            class="ml-2"
            density="compact"
            hide-details="auto"
            @update:model-value="nightLEDSwitched"
          />
        </v-col>
      </v-row>
    </v-container>
    <ContainerWithLabel label="Darstellung">
      <v-btn-group variant="outlined" color="primary" divided>
        <v-btn icon="mdi-arrow-up" @click="Icon = 'arrow-up'" />
        <v-btn icon="mdi-arrow-down" @click="Icon = 'arrow-down'" />
        <v-btn
          icon="mdi-lightbulb-on-outline"
          @click="Icon = 'lightbulb-on-outline'"
        />
        <v-text-field
          v-model="Icon"
          label="Icon"
          width="350px"
          color="primary"
        />

        <v-btn
          v-tooltip:right="
            'Öffnet externen Link mit Liste von verfügbaren Icons.'
          "
          as="a"
          color="primary"
          variant="outlined"
          href="https://materialdesignicons.com/"
          target="_blank"
        >
          Weitere Icons</v-btn
        >
      </v-btn-group>
    </ContainerWithLabel>
    <v-text-field
      v-model="Text"
      label="Text"
      maxlength="18"
      color="primary"
      class="mt-4"
      density="compact"
    />
    <div v-if="keyConfig?.CommandGrp?.value === 5">
      <table>
        <thead>
          <tr style="text-align: left">
            <th width="130px">Befehl</th>
            <th width="110px">Zeit [s]</th>
            <th width="260px">Befehl</th>
            <th>LED</th>
            <th>Info</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="table-title">Drücken</td>
            <td>
              <v-number-input
                v-model="Time1"
                :min="0"
                :max="6000"
                :step="0.1"
                type="number"
                density="compact"
                hide-details="auto"
                control-variant="stacked"
              />
            </td>
            <td>
              <v-select
                v-model="keyConfig.Command1.value"
                :items="MaxFlexJokerButtonCommands"
                item-title="name"
                density="compact"
                hide-details="auto"
              />
            </td>
            <td>
              <v-select
                v-model="keyConfig.Indication1.value"
                :items="[
                  { title: '-', value: 0 },
                  { title: 'Ein', value: 1 },
                  { title: 'Aus', value: 2 },
                ]"
                density="compact"
                hide-details="auto"
              />
            </td>
            <td>
              <v-btn
                v-tooltip:bottom="
                  `Der Befehl wird ausgeführt, sobald die Taste für die mit 'Auslöseverzögerung' definierte Zeit gedürckt gehalten wird. Wird zusätzlich die LED eingeschaltet, blinkt bzw. leuchtet diese, bis sie durch einen der beiden anderen JOKER Befehle wieder ausgeschaltet wird.`
                "
                class="ml-1"
                density="compact"
                icon="mdi-help-circle-outline"
              />
            </td>
          </tr>
          <tr>
            <td class="table-title">Halten</td>
            <td>
              <v-number-input
                v-model="Time2"
                :min="0"
                :max="6000"
                :step="0.1"
                type="number"
                control-variant="stacked"
                density="compact"
                hide-details="auto"
              />
            </td>
            <td>
              <v-select
                v-model="keyConfig.Command2.value"
                :items="MaxFlexJokerButtonCommands"
                item-title="name"
                density="compact"
                hide-details="auto"
              />
            </td>
            <td>
              <v-select
                v-model="keyConfig.Indication2.value"
                :items="[
                  { title: '-', value: 0 },
                  { title: 'Ein', value: 1 },
                  { title: 'Aus', value: 2 },
                ]"
                density="compact"
                hide-details="auto"
              />
            </td>
            <td>
              <v-btn
                v-tooltip:bottom="
                  `Der Befehl wird ausgeführt, sobald die Taste für die mit 'Auslöseverzögerung' definierte Zeit gedürckt gehalten wird. Wird zusätzlich die LED eingeschaltet, blinkt bzw. leuchtet diese, bis sie durch einen der beiden anderen JOKER Befehle wieder ausgeschaltet wird.`
                "
                class="ml-1"
                density="compact"
                icon="mdi-help-circle-outline"
              />
            </td>
          </tr>
          <tr>
            <td style="text-align: left">Loslassen</td>
            <td>
              <v-number-input
                v-model="TimeRls"
                :min="0"
                :max="6000"
                :step="0.1"
                type="number"
                control-variant="stacked"
                density="compact"
                hide-details="auto"
              />
            </td>
            <td rowspan="2">
              <v-select
                v-model="keyConfig.CommandRls.value"
                :items="MaxFlexJokerButtonCommands"
                item-title="name"
                density="compact"
                hide-details="auto"
              />
            </td>
            <td rowspan="2">
              <v-select
                v-model="keyConfig.IndicationRls.value"
                :items="[
                  { title: '-', value: 0 },
                  { title: 'Ein', value: 1 },
                  { title: 'Aus', value: 2 },
                ]"
                density="compact"
                hide-details="auto"
              />
            </td>
            <td rowspan="2">
              <v-btn
                v-tooltip:bottom="
                  `Der Befehl wird aktiviert, sobald die Taste für die mit 'Auslöseverzögerung' definierte Zeit gedrückt gehalten wird. Nach dem Loslassen der Taste wird der Befehl nach der mit 'Zeitverzögerung nach ClickOff' definierten Zeit ausgeführt. Wird zusätzlich die LED eingeschaltet, blinkt bzw. leuchtet diese, bis sie durch einen der beiden anderen JOKER-Befehle wieder ausgeschaltet wird.`
                "
                class="ml-1"
                density="compact"
                icon="mdi-help-circle-outline"
              />
            </td>
          </tr>
          <tr style="line-height: 20px">
            <td class="table-title">Verzögerung nach loslassen</td>
            <td>
              <v-number-input
                v-model="DelayRls"
                :min="0"
                :max="60000"
                :step="1"
                type="number"
                control-variant="stacked"
                density="compact"
                hide-details="auto"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <v-btn-group divided color="primary" class="mb-4 mt-4">
      <v-btn variant="elevated" @click="closeModal">Übernehmen</v-btn>
      <v-btn variant="outlined" @click="cancel">Abbrechen</v-btn>
    </v-btn-group>
    <hr />

    <v-expansion-panels>
      <v-expansion-panel title="Info">
        <v-expansion-panel-text>
          <v-sheet class="my-2">
            <p>
              <b>Kanal</b><br />
              Der Kanal kann frei gewählt werden. Alle Empfänger, welche auf
              einen Kanal eingelernt wurden, reagieren dabei auf den
              enstprechenden Tastendruck.
            </p>
          </v-sheet>
          <v-sheet class="my-2">
            <b>Funktion</b><br />
            Hier kann die Funktion der Taste definiert werden.
            <ul>
              <li>
                <b>NONE</b><br />
                <ul>
                  <li>Keine Funktion zugeordnet</li>
                </ul>
              </li>
              <li>
                <b>AUF</b><br />
                <ul>
                  <li>
                    Kurzer Tastendruck = AUF Impuls.
                    <i
                      >Die Jalousie wippt auf. Die Lichtquelle geht auf die
                      letzte Helligkeit. Bei bereits eingeschalteten Dimmern
                      beginnt die Dimmfahrt.</i
                    >
                  </li>
                  <li>
                    Langer Tastendruck = AUF konstant.
                    <i
                      >Die Jalousie fährt hoch. Die Lichtquelle geht auf
                      Volllicht.</i
                    >
                  </li>
                </ul>
              </li>
              <li>
                <b>AB</b><br />
                <ul>
                  <li>
                    Kurzer Tastendruck = AB Impuls.
                    <i>Die Jalousie wippt ab. Die Lichtquelle schaltet aus.</i>
                  </li>
                  <li>
                    Langer Tastendruck = AB konstant.
                    <i
                      >Die Jalousie fährt herunter. Die Lichtquelle schaltet
                      aus.</i
                    >
                  </li>
                </ul>
              </li>
              <li>
                <b>TOGGLE</b><br />
                <ul>
                  <li>
                    Kurzer Tastendruck = Umschalten (toggeln).
                    <i>Die Lichtquelle schaltet ein bzw. aus.</i>
                  </li>
                  <li>
                    Langer Tastendruck (halten) = Dimmen.
                    <i
                      >Die Lichtquelle dimmt (sofern dimmbar), solange die Taste
                      gehalten wird. Beim Loslassen endet das Dimmen.</i
                    >
                  </li>
                  <li>Doppelklick = Ausschalten.</li>
                  <li>Doppelklick + halten = Volllicht.</li>
                </ul>
              </li>
              <li>
                <b>SZENE</b><br />
                <ul>
                  <li>
                    Kurzer Tastendruck = Position abrufen.
                    <i
                      >Das Empfangsmodul schaltet auf den Wert des
                      Positionsspeichers.</i
                    >
                  </li>
                  <li>
                    Langer Tastendruck = Position speichern.
                    <i
                      >Das Empfangsmodul speichert die aktuell eingestellte
                      Position.</i
                    >
                  </li>
                  <li>
                    Doppelklick = AB konstant.
                    <i
                      >Die Jalousie fährt herunter. Die Lichtquelle schaltet
                      aus.</i
                    >
                  </li>
                  <li>
                    Doppelklick + halten = AUF konstant.
                    <i
                      >Die Jalousie fährt hoch. Die Lichtquelle schaltet auf
                      Volllicht.</i
                    >
                  </li>
                </ul>
              </li>
              <li>
                <b>JOKER</b><br />
                Frei definierbare Befehle für folgende Aktionen:
                <ul>
                  <li>
                    Die Taste wird gedrückt und gehalten. Der Befehl 1 wird
                    ausgeführt, sofern Zeit 1 erreicht wurde.
                  </li>
                  <li>
                    Die Taste wird weiterhin gehalten. Der Befehl 2 wird
                    ausgeführt, sofern Zeit 2 erreicht wurde.
                  </li>
                  <li>
                    Die Taste wird losgelassen (ClickOff). Der Befehl 3 wird
                    ausgeführt, sofern Zeit 3 erreicht wurde. Falls gewünscht
                    kann auch noch eine Zeitverzögerung nach dem ClickOff
                    definiert werden.
                  </li>
                </ul>
              </li>
            </ul>
          </v-sheet>
          <v-sheet class="my-2">
            <p>
              <b>Erhöhte Priorität</b><br />
              Durch die erhöhte Prioriät kann ein mit Level 1 gesperrter
              Empfänger übersteuert werden. Diese Funktion sollte mit Bedacht
              und nur in Ausnahmesituationen aktiviert werden. Ansonsten kann
              ein Sicherheitsrisiko bestehen, da allenfalls aus
              Sicherheitsgründen gesperrte Empfänger übersteuert werden können.
            </p>
          </v-sheet>
          <v-sheet class="my-2">
            <p>
              <b>Nacht-LED</b><br />
              Nach Wunsch kann eine LED bestimmt werden, welche in regelmässigen
              Abständen aufblitzt, z.B. zwecks Auffinden in der Dunkelheit. Die
              Helligkeit und die Frequenz kann unter "Layout" im Berich
              "Funktions-LED" eingestellt werden.
            </p>
          </v-sheet>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup lang="ts">
import hotkeys from 'hotkeys-js'
import isEqual from 'lodash.isequal'
import merge from 'lodash.merge'
import {
  computed,
  onBeforeMount,
  onMounted,
  onUnmounted,
  Ref,
  ref,
  watch,
} from 'vue'

import {
  LocatingKeyButtonMap,
  MaxFlexButtonFunction,
  MaxFlexConfig,
  MaxFlexJokerButtonCommands,
  MaxFlexKeyConfig,
} from '@/apps/brelag/common/models/maxflex/maxflex'
import ContainerWithLabel from '@/components/common/ContainerWithLabel.vue'
import { useConfirmationDialog } from '@/util/composables/useConfirmationDialog'

type MaxFlexButtonConfigEditorProps = {
  config: MaxFlexConfig
  buttonNum: number
}

const props = defineProps<MaxFlexButtonConfigEditorProps>()
const channels = [...Array(8).keys()].map((x) => {
  return {
    name: `Kanal ${x + 1}`,
    value: x,
  }
})
const configRef: Ref<MaxFlexConfig> = ref(null)

const originalConfig: Ref<MaxFlexConfig> = ref(null)

const Time1: Ref<number> = ref(null) // [0.1s] saved as 0.1 sec, displayed as sec
const Time2: Ref<number> = ref(null) // [0.1s] saved as 0.1 sec, displayed as sec
const TimeRls: Ref<number> = ref(null) // [0.1s] saved as 0.1 sec, displayed as sec
const DelayRls: Ref<number> = ref(null) // [s]
const Icon = ref('')
const Text = ref('')
const emit = defineEmits(['input', 'close'])

onBeforeMount(() => {
  configRef.value = props.config
  Time1.value = keyConfig.value.Time1.value / 10
  Time2.value = keyConfig.value.Time2.value / 10
  TimeRls.value = keyConfig.value.TimeRls.value / 10
  DelayRls.value = keyConfig.value.DelayRls.value

  if (!keyConfig.value?.Icon) {
    keyConfig.value.Icon = { value: '' }
  }
  if (!keyConfig.value?.Text) {
    keyConfig.value.Text = { value: '' }
  }
  Icon.value = keyConfig.value?.Icon.value
  Text.value = keyConfig.value?.Text.value
})

onMounted(() => {
  hotkeys(
    'esc',
    { scope: 'MaxFlexButtonConfigEditor', keyup: true },
    (event) => {
      // only fire event on keyup to avoid closing confirm dialog directly
      if (event.type === 'keyup') {
        event.preventDefault()
        cancel()
      }
    }
  )
  hotkeys.setScope('MaxFlexButtonConfigEditor')

  // keep original config to detect changes
  originalConfig.value = JSON.parse(JSON.stringify(configRef.value))
})

onUnmounted(() => {
  hotkeys.unbind('esc', 'MaxFlexButtonConfigEditor')
  hotkeys.setScope('MaxFlexConfigEditor')
})

watch(Time1, Time1Changed)
watch(Time2, Time2Changed)
watch(TimeRls, TimeRlsChanged)
watch(DelayRls, DelayRlsChanged)
watch(Text, TextChanged)
watch(Icon, IconChanged)

function Time1Changed() {
  keyConfig.value.Time1.value = Time1.value * 10
}

function Time2Changed() {
  keyConfig.value.Time2.value = Time2.value * 10
}

function TimeRlsChanged() {
  keyConfig.value.TimeRls.value = TimeRls.value * 10
}

function DelayRlsChanged() {
  keyConfig.value.DelayRls.value = DelayRls.value
}

function TextChanged() {
  keyConfig.value.Text.value = Text.value
}

function IconChanged() {
  keyConfig.value.Icon.value = Icon.value
}

const nightLED = computed(() => {
  return (
    LocatingKeyButtonMap[props.buttonNum] ===
    configRef.value?.LocatingKey?.value
  )
})

const keyConfig = computed((): MaxFlexKeyConfig => {
  return configRef.value?.keys?.[props.buttonNum]
})

function nightLEDSwitched(value) {
  emit('input', value, props.buttonNum)
}

function closeModal() {
  emit('close')
}

const confirm = useConfirmationDialog()
async function cancel() {
  if (isEqual(configRef.value, originalConfig.value)) {
    // no changes, close immediatly
    closeModal()
  } else {
    const isConfirmed = await confirm({
      content: 'Sind Sie sicher, dass Sie die Änderung verwerfen möchten?',
    })
    if (!isConfirmed) return
    // revert changes
    // need to merge into config object, cannot reassign configRef.value to a new object
    merge(configRef.value, originalConfig.value)
    closeModal()
  }
}
</script>

<style lang="scss" scoped>
.table-title {
  text-align: left;
}
</style>
